import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const removeFieldStmtInstruction = `
#### Remove field

- Syntax: \`remove field <field_name> in <form_name>;\`
- Example: \`remove field name in ProductForm;\`
`;
export const stmtRemoveStructureField = ({ fieldName, formName }) => {
    return `remove field ${fieldName} in ${formName};`;
};
export const removeStructureFieldHandler = createStructureStatementHandler({
    type: 'remove field',
    parse: line => {
        const match = /^remove field (?<fieldName>[\w.]+) in (?<formName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove field',
                fieldName: match.groups.fieldName,
                formName: match.groups.formName,
            }
            : null;
    },
    apply: (stmt, builder) => builder.updateStructure(it => it.removeField({
        fieldName: stmt.fieldName,
        formName: stmt.formName,
    })),
});
//# sourceMappingURL=RemoveFieldStmt.js.map